import { connect } from 'react-redux';
import { selectSiteSpaceContentType } from '../../selectors/ContentFilterSelectors';
import { siteUrlsSelector } from '../../selectors/SiteUrlsSelectors';
import { AppState } from '../../state/AppState';
import { MapStateToProps } from '../../utils/ConnectUtils';
import {
  SiteSpace,
  SiteSpaceStateProps,
} from './SiteSpace';

const mapStateToProps: MapStateToProps<SiteSpaceStateProps> = (state: AppState) => ({
  siteSpaceContentType: selectSiteSpaceContentType(state),
  urls: siteUrlsSelector(state)
});

export const ConnectedSiteSpace = connect(mapStateToProps)(SiteSpace);
